import React, { useEffect, useRef, useState } from "react";

import { ControlType } from "../types";
import { IControlEntry } from "./IControlEntry";
import Modal from "react-bootstrap/esm/Modal";
import { Registry } from "./ComponentRegistry";
import clsx from "clsx";

export const ComponentsDialog = ({ show, onSelect, onHideModal }: {
    show: boolean,
    onSelect: (type: ControlType) => void,
    onHideModal: () => void,
}) => {
    const handleOnSelect = (component: IControlEntry) => {
        onSelect(component.type);
        onHideModal();
    }

    return (
        <Modal show={show} onHide={onHideModal} dialogClassName="min-w-75">
            <Modal.Header closeButton className="py-5">
                <Modal.Title>Components</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form>
                    <ComponentSelector onSelect={handleOnSelect} />
                </form>
            </Modal.Body>
        </Modal>)
}

const ComponentSelector = ({ onSelect }: {
    onSelect: (component: IControlEntry) => void,
}) => {
    const ref = useRef<HTMLInputElement>(null)
    const [searchText, setSearchText] = useState<string>('');

    useEffect(() => {
        if (ref.current)
            ref.current.focus()
        // eslint-disable-next-line
    }, [ref.current])

    const systemComponents = () => {
        const text = searchText.toLowerCase()
        const components = Registry.controls;
        return components.filter(p => p.name.toLowerCase().indexOf(text) !== -1)
            .sort((a, b) => a.name.localeCompare(b.name))
    }

    const selectComponent = (component: IControlEntry) => {
        onSelect(component);
    }

    return (
        <div className="card card-body py-0">
            <div className="input-group input-group-sm position-sticky mb-5">
                <input
                    ref={ref}
                    type="search"
                    placeholder="Search"
                    value={searchText}
                    onKeyDown={e => e.stopPropagation()}
                    onChange={(e) => {
                        e.stopPropagation()
                        e.preventDefault()
                        setSearchText(e.target.value)
                    }}
                    className="form-control" />
                <span className="input-group-text">
                    <i className="las la-search fs-5"></i>
                </span>
            </div>
            <div className="mh-xl-400px overflow-scroll">
                <ComponentsPanel
                    title="System"
                    className="mb-5"
                    components={systemComponents()}
                    onSelect={selectComponent} />
            </div>
        </div>)
}

const ComponentsPanel = ({ title, components, className, onSelect }: {
    title: string,
    components: IControlEntry[],
    className?: string,
    onSelect: (component: IControlEntry) => void
}) => {
    return <div className={clsx(className, "card card-body p-0")}>
        <h5 className="text-gray-700 mb-5">{title}</h5>
        <div className="d-flex flex-wrap justify-content-start">
            {components.map(component =>
                <React.Fragment key={component.id}>
                    <ComponentButton component={component} onSelect={onSelect} />
                </React.Fragment>
            )}
        </div>
    </div>
}

const ComponentButton = ({ component, onSelect }: {
    component: IControlEntry,
    onSelect: (component: IControlEntry) => void
}) => {
    return <div className="w-xl-25 py-1 px-2" >
        <button
            type="button"
            title={component.name}
            onClick={() => onSelect(component)}
            className="btn btn-outline btn-outline-primary w-100">
            <div className="d-flex align-items-center text-truncate">
                <i className="las la-object-group text-gray-700 fs-1"></i>
                <div className='fw-semibold text-start text-gray-700 flex-fill fs-7'>
                    {component.name}
                </div>
            </div>
        </button>
    </div>
}